import axios from "@/api/axiosInstance";
import { ListLibraryModulesRequest, ListLibraryModulesResponse } from "./types";

export const listLibraryModules = async (
  params: ListLibraryModulesRequest = {},
): Promise<ListLibraryModulesResponse> => {
  const response = await axios.get<ListLibraryModulesResponse>(
    "/api/private/learning-center/module-library",
    {
      params: {
        search: params.search ?? undefined,
        status: params.status ?? undefined,
        difficulty: params.difficulty ?? undefined,
        tag: params.tag ?? undefined,
        page: params.page,
        pageSize: params.pageSize,
        sortBy: params.sortBy,
        sortOrder: params.sortOrder,
      },
    },
  );
  return response.data;
};
